
import ReactQuill from "react-quill"
const EditNewResponseHeader = ({response}) => {
  return (
    <>
      <div className="data-table">
            <span>מצב ההגשה</span> <div >{response?.body?"הוגש למתן ציון" : "אין נסיונות"}</div>
            <span>מצב מתן ציון</span> <div>{response?.grade? response.grade : "לא ניתן ציון" } </div>
            <span>עדכון אחרון</span> <div>{response?.updatedAt? response.updatedAt : ""}</div>
             {response?.notes&& <><span>הערות בדיקה</span> <div>
             <ReactQuill
                     theme='bubble'
                    readOnly
                    value={response.notes}
                    
                    ></ReactQuill>
              </div></>} 
        </div>
    </>
  )
}

export default EditNewResponseHeader